
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/speedcms",
      function () {
        return require("private-next-pages/product/speedcms/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/speedcms"])
      });
    }
  